export default "__VITE_ASSET__DsZDKFpd__"